import { render } from "./CommunityProfile.vue?vue&type=template&id=717bb03c&scoped=true"
import script from "./CommunityProfile.vue?vue&type=script&lang=js"
export * from "./CommunityProfile.vue?vue&type=script&lang=js"

import "./CommunityProfile.vue?vue&type=style&index=0&id=717bb03c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717bb03c"]])

export default __exports__